<div
  class="bn-color-picker-color--wrap"
  [ngClass]="{
    'bn-color-picker-color--wrap--selected': combinedColor === color,
  }">
  <div
    class="bn-color-picker-color"
    [style.background-color]="color"></div>
</div>
